/* @flow */

import React, { Fragment } from 'react'
import { List } from 'immutable'
import { nonEmptyString, numeric, number, maxLength, minLength } from 'atpjs/validation/validators'
import { and, or } from 'atpjs/validation/functions'
import { validationHasError } from 'atpjs/validation/validations'
import { TextInput, TelInput } from 'atpjs/components/form/input'
import Error from 'atpjs/components/form/error'
import NavigationButtons from 'atpjs/components/navigation_buttons'
import i18n from 'atpjs/helpers/i18n'
import Step from 'tve/views/step'
import Application from 'tve/components/application'
import Navigation from 'tve/components/navigation'
import { BigOptionRadio } from 'tve/components/forms/big_option'
import BranchComponent from 'tve/components/branch'
import { getBranch } from 'tve/api/atp'
import { mediumsByData, topicsBySubject } from 'tve/helpers/logic'

import type { PrefixType } from 'atpjs/helpers/i18n'

const t = i18n.prefix(['branch'])

const Branches = ({ branches, selectHandler, data }) => {
  const advisor = data.get('advisor')
  const advisorBranches = advisor && advisor.get('branches')

  return (
    <div className="atp-grid">
      {(advisor && advisorBranches ? advisorBranches : branches).map((branch) => {
        return <BranchComponent key={branch.get('id')} selectHandler={selectHandler} branch={branch} />
      })}
    </div>
  )
}

class Branch extends Step {
  sendData = false

  constructor(props) {
    super(props)

    this.state.branches = List()
    this.state.mediumValues = []
  }

  componentDidMount() {
    this.loadBranches()
    this.setState({
      mediumValues: mediumsByData(this.getHandler())
    })
  }

  componentWillUnmount() {
    if (this.branchesPromise) this.branchesPromise.cancel()
  }

  validations(trans: PrefixType) {
    const medium = this.getData(['medium'])
    return {
      medium: nonEmptyString(trans(['medium'])),
      ...(medium == 'bank' ? { branch: { id: number(trans(['branch'])) } } : {}),
      ...(medium == 'personal'
        ? {
            appointment: {
              street: nonEmptyString(),
              zip: and(numeric(), or(maxLength(4), minLength(4))),
              city: nonEmptyString()
            }
          }
        : {})
    }
  }

  loadBranches = (medium) => {
    const data = this.getHandler()
    const advisorBranches = data.getIn(['advisor', 'branches'])
    if (advisorBranches) {
      this.setState({ branches: advisorBranches })
    } else {
      const topicIds = topicsBySubject(this.getHandler()).map((topic) => topic.get('id'))
      this.branchesPromise = getBranch({ topicIds, locale: i18n.locale }).then((branches) => {
        this.setState({ branches })
      })
    }

    return medium
  }

  selectBranchHandler = (branch) => {
    const data = this.getHandler()
    data.set('branch', branch)
    return this.next()
  }

  render() {
    const { branches, mediumValues } = this.state
    const inputSetProps = this.inputSetProps()
    const branchErrorMessage = inputSetProps(['branch']).errorMessage
    const data = this.getHandler()
    const medium = data.get('medium')

    return (
      <Application
        title={t(['title'])}
        name={i18n.trans(['tve', 'title'])}
        navigation={<Navigation data={this.getHandler()} next={this.previousHandler} />}>
        <form onSubmit={this.onSubmit}>
          <BigOptionRadio
            {...inputSetProps(['medium'], { label: null /* preProcess: this.loadBranches */ })}
            values={mediumValues}
          />
          {medium == 'bank' && <Branches branches={branches} selectHandler={this.selectBranchHandler} data={data} />}
          {medium == 'personal' && (
            <Fragment>
              <div className="atp-grid">
                <div className="atp-grid-1-1">
                  <TextInput {...inputSetProps(['appointment', 'street'])} />
                </div>
              </div>
              <div className="atp-grid atp-margin-top-no atp-margin-bottom-s">
                <div className="atp-grid-4-1 atp-grid-m-1-1 atp-offset-m-1-0">
                  <TelInput {...inputSetProps(['appointment', 'zip'])} maxLength="4" pattern="\d*" />
                </div>
                <div className="atp-grid-4-3 atp-grid-m-1-1 atp-offset-m-1-0">
                  <TextInput {...inputSetProps(['appointment', 'city'])} />
                </div>
              </div>
            </Fragment>
          )}
          <Error
            errorMessage={
              validationHasError(branchErrorMessage && branchErrorMessage.toJS()) &&
              i18n.trans(['attributes', 'errors', 'branch'])
            }
          />
          <NavigationButtons
            nextAction={['video', 'phone', 'personal'].includes(medium) ? this.nextHandler : null}
            order={['previous', 'next']}
            previousAction={this.previousHandler}
            previousProps={{ className: 'atp-show-for-l-down' }}
          />
        </form>
      </Application>
    )
  }
}

export default Branch
